module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'has-error': _vm.invalid, 'has-success': _vm.isDirty, 'i-am-sunny': _vm.disabled
    }
  }, [(_vm.label) ? _c('label', {}, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _c('div', [_c('date-picker', {
    class: {
      'has-error': _vm.invalid, 'has-success': _vm.isDirty, 'i-am-sunny': _vm.disabled
    },
    attrs: {
      "config": _vm.config,
      "disabled": _vm.disabled
    },
    on: {
      "dp-change": _vm.update
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "help-block animated fadeInDown"
  }, [(_vm.invalid && (_vm.customErrorMsg || _vm.errorMsg)) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.customErrorMsg || _vm.errorMsg) + "\n        ")]) : _c('span', {
    staticClass: "ghostly"
  }, [_vm._v("\n             \n        ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dff5b414"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/forms/wc-date.vue
// module id = 830
// module chunks = 3